<template>
  <div class="consend">
    <!-- 我的发布 -->
    <div class="consend_title">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="专利" name="first">
          <div class="consend_title_top">
            <!-- 上 -->
            <div class="consend_title_top_fist">
              <div
                v-for="(item, index) in release_tltle"
                :key="index"
                @click="tab(index)"
                :class="{ active: index == ins }"
              >
                {{ item.label }}
              </div>
            </div>
            <!-- 中 -->
            <div
              v-for="(item, index) in Hot_list"
              :key="index"
              class="consend_middle"
              @click="Go_PatentDetails(item.id)"
            >
              <!-- 左 -->
              <div class="consend_bottom_left">
                <!-- 照片 -->
                <div class="consend_bottom_i">
                  <img
                    v-if="item.chart_img == '' ? false : true"
                    class="consend_bottom_img"
                    :src="item.chart_img"
                  />
                </div>
                <!-- 字 -->
                <div>
                  <div class="consend_bottom_text">{{ item.patent_name }}</div>
                  <div class="text_middle">
                    <div class="consend_bottom_data">
                      {{ item.authorization_date }}
                    </div>
                    <el-tag
                      effect="dark"
                      :type="
                        item.status == '1'
                          ? 'success'
                          : item.status == '2'
                          ? 'danger'
                          : item.status == '3'
                          ? 'warning'
                          : item.status == '4'
                          ? 'info'
                          : ''
                      "
                      >{{
                        item.status == "1"
                          ? "已发布"
                          : item.status == "2"
                          ? "审核失败"
                          : item.status == "3"
                          ? "草稿"
                          : item.status == "4"
                          ? "已撤回"
                          : "待审核"
                      }}</el-tag
                    >
                  </div>
                  <div class="text_bottom">
                    <div class="consend_bottom_t">
                      <span>资讯</span>：<span>{{
                        item.num_consultations
                      }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>收藏</span>：<span>{{ item.num_collect }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>分享</span>：<span>{{ item.num_transmit }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 右 -->
              <div v-if="item.status == '1'">
                <div class="consend_right">
                  <div class="icon_img">
                    <img src="../../assets/img/recall.png" alt="" />
                  </div>
                  <div class="icon_text" @click.stop="messageList(item.id)">
                    撤回
                  </div>
                </div>
              </div>
              <div v-if="item.status == '4'">
                <div class="consend_right">
                  <div class="icon_img" @click.stop="popList(item.id)">
                    重新上线
                  </div>
                  <div class="icon_text" @click.stop="deletelist(item.id)">
                    删除
                  </div>
                </div>
              </div>
              <div
                v-if="
                  item.status == '2' || item.status == '3' || item.status == '0'
                "
              >
                <div class="consend_right">
                  <div class="icon_img">
                    <img src="../../assets/img/xiugaiicon.png" alt="" />
                  </div>
                  <div class="icon_text" @click.stop="amendList(item.id)">
                    修改
                  </div>
                </div>
              </div>
            </div>
            <!-- 下 -->
            <div class="condent_page">
              <el-pagination
                :page-size="limit"
                @current-change="handleCurrentChange"
                :current-page="page"
                background
                layout="prev, pager, next"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="研报" name="second">
          <div class="consend_title_top">
            <!-- 上 -->
            <div class="consend_title_top_fist">
              <div
                v-for="(item, indexs) in release_tltle"
                :key="indexs"
                @click="tabs(indexs)"
                :class="{ active: indexs == inss }"
              >
                {{ item.label }}
              </div>
            </div>
            <!-- 中 -->
            <div
              v-for="(item, index) in report_list"
              :key="index"
              class="consend_middle"
              @click="Go_ResearchReportDetails(item.id)"
            >
              <!-- 左 -->
              <div class="consend_bottom_left">
                <!-- 照片 -->
                <div class="consend_bottom_i">
                  <img
                    v-if="item.img == null ? false : true"
                    class="consend_bottom_img"
                    :src="item.img"
                  />
                </div>
                <!-- 字 -->
                <div>
                  <div class="consend_bottom_text">
                    {{ item.chinese_title }}
                  </div>
                  <div class="text_middle">
                    <div class="consend_bottom_data">
                      {{ item.create_time }}
                    </div>
                    <el-tag
                      effect="dark"
                      :type="
                        item.status == '1'
                          ? 'success'
                          : item.status == '2'
                          ? 'danger'
                          : item.status == '3'
                          ? 'warning'
                          : item.status == '4'
                          ? 'info'
                          : ''
                      "
                      >{{
                        item.status == "1"
                          ? "已发布"
                          : item.status == "2"
                          ? "审核失败"
                          : item.status == "3"
                          ? "草稿"
                          : item.status == "4"
                          ? "已撤回"
                          : "待审核"
                      }}</el-tag
                    >
                  </div>
                  <div class="text_bottom">
                    <div class="consend_bottom_t">
                      <span>曝光</span>：<span>{{ item.num_exposure }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>评论</span>：<span>{{ item.num_comment }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>点赞</span>：<span>{{ item.num_praise }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>收藏</span>：<span>{{ item.num_collect }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>分享</span>：<span>{{ item.num_transmit }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>下载</span>：<span>{{ item.num_download }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 右 -->
              <div v-if="item.status == '1'">
                <div class="consend_right">
                  <div class="icon_img">
                    <img src="../../assets/img/recall.png" alt="" />
                  </div>
                  <div class="icon_text" @click.stop="messageLists(item.id)">
                    撤回
                  </div>
                </div>
              </div>
              <div v-if="item.status == '4'">
                <div class="consend_right">
                  <div class="icon_img" @click.stop="popLists(item.id)">
                    重新上线
                  </div>
                  <div class="icon_text" @click.stop="deletelists(item.id)">
                    删除
                  </div>
                </div>
              </div>
              <div
                v-if="
                  item.status == '2' || item.status == '3' || item.status == '0'
                "
              >
                <div class="consend_right">
                  <div class="icon_img">
                    <img src="../../assets/img/xiugaiicon.png" alt="" />
                  </div>
                  <div class="icon_text" @click.stop="amendLists(item.id)">
                    修改
                  </div>
                </div>
              </div>
            </div>
            <!-- 下 -->
            <div class="condent_page">
              <el-pagination
                :page-size="limits"
                @current-change="handleCurrentChanges"
                :current-page="pages"
                background
                layout="prev, pager, next"
                :total="totals"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="资讯" name="third">
          <div class="consend_title_top">
            <!-- 上 -->
            <div class="consend_title_top_fist">
              <div
                v-for="(item, indexes) in release_tltle"
                :key="indexes"
                @click="tabes(indexes)"
                :class="{ active: indexes == inses }"
              >
                {{ item.label }}
              </div>
            </div>
            <!-- 中 -->
            <div
              v-for="(item, index) in result"
              :key="index"
              class="consend_middle"
              @click="Go_InformationDetails(item.id)"
            >
              <!-- 左 -->
              <div class="consend_bottom_left">
                <!-- 照片 -->
                <div class="consend_bottom_i">
                  <img
                    v-if="item.img == '' ? false : true"
                    class="consend_bottom_img"
                    :src="item.img"
                  />
                </div>
                <!-- 字 -->
                <div>
                  <div class="consend_bottom_text">
                    {{ item.title }}
                  </div>
                  <div class="text_middle">
                    <div class="consend_bottom_data">
                      {{ item.create_time }}
                    </div>
                    <el-tag
                      effect="dark"
                      :type="
                        item.status == '1'
                          ? 'success'
                          : item.status == '2'
                          ? 'danger'
                          : item.status == '3'
                          ? 'warning'
                          : item.status == '4'
                          ? 'info'
                          : ''
                      "
                      >{{
                        item.status == "1"
                          ? "已发布"
                          : item.status == "2"
                          ? "审核失败"
                          : item.status == "3"
                          ? "草稿"
                          : item.status == "4"
                          ? "已撤回"
                          : "待审核"
                      }}</el-tag
                    >
                  </div>
                  <div class="text_bottom">
                    <div class="consend_bottom_t">
                      <span>阅读</span>：<span>{{ item.num_collect }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>评论</span>：<span>{{ item.num_comment }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>点赞</span>：<span>{{ item.num_praise }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>收藏</span>：<span>{{ item.num_favorite }}</span>
                    </div>
                    <div class="consend_bottom_t">
                      <span>分享</span>：<span>{{ item.num_recommend }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 右 -->
              <div v-if="item.status == '1'">
                <div class="consend_right">
                  <div class="icon_img">
                    <img src="../../assets/img/recall.png" alt="" />
                  </div>
                  <div class="icon_text" @click.stop="messageListes(item.id)">
                    撤回
                  </div>
                </div>
              </div>
              <div v-if="item.status == '4'">
                <div class="consend_right">
                  <div class="icon_img" @click.stop="popListes(item.id)">
                    重新上线
                  </div>
                  <div class="icon_text" @click.stop="deletelistes(item.id)">
                    删除
                  </div>
                </div>
              </div>
              <div
                v-if="
                  item.status == '2' || item.status == '3' || item.status == '0'
                "
              >
                <div class="consend_right">
                  <div class="icon_img">
                    <img src="../../assets/img/xiugaiicon.png" alt="" />
                  </div>
                  <div class="icon_text" @click.stop="amendListe(item.id)">
                    修改
                  </div>
                </div>
              </div>
            </div>
            <!-- 下 -->
            <div class="condent_page">
              <el-pagination
                :page-size="limites"
                @current-change="handleCurrentChangees"
                :current-page="pageeses"
                background
                layout="prev, pager, next"
                :total="totales"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import {
  userinfo_delcontent,
  del_report,
  delpatent,
  article_userAgain,
  article_userPatent,
  article_userReport,
  user_content,
  userinfo_withdrawpatent,
  userinfo_withdrawreport,
  withdraw,
} from "../../api/api";
export default {
  metaInfo() {
    return {
      title: "我的发布",
      meta: [
        {
          name: "keywords",
          content:
            "驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。",
        },
        {
          name: "description",
          content:
            " 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网",
        },
      ],
    };
  },
  name: "releases",
  inject: ["reload"],
  created() {
    this.query();
    this.Report();
    this.querylist();
  },
  mounted() {
    let name = sessionStorage.getItem("currentTabs");
    // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
    if (name) {
      this.activeName = name;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 在离开此路由之后清除保存的状态（我的需求是只需要在当前tab页操作刷新保存状态，路由切换之后不需要保存）
    // 根据个人需求决定清除的时间
    sessionStorage.removeItem("currentTabs");
    next();
  },
  data() {
    return {
      activeName: "first",
      result: [],
      ins: 0,
      inss: 0,
      inses: 0,
      page: 1,
      pages: 1,
      pageeses: 1,
      limit: 10,
      limites: 10,
      limits: 10,
      total: this.total,
      totals: this.totals,
      totales: this.totales,
      active: 1,
      Hot_list: [],
      report_list: [],
      reports: [],
      typeList: [],
      typeLists: [],
      typeListes: [],
      queryid: [],
      type1: 1,
      type2: 2,
      type3: 3,
      release_tltle: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "已发布",
          value: 1,
        },
        {
          label: "审核失败",
          value: 2,
        },
        {
          label: "草稿",
          value: 3,
        },
        {
          label: "已撤回",
          value: 4,
        },
      ],
    };
  },
  methods: {
    // 跳转资讯详情
    Go_InformationDetails(id) {
      this.$router.push({ name: "InformationDetails", query: { id: id } });
    },
    // 跳转研报详情
    Go_ResearchReportDetails(id) {
      this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
    },
    // 跳转专利详情页面
    Go_PatentDetails(id) {
      this.$router.push({ name: "PatentDetails", query: { id: id } });
    },
    // 资讯
    querylist() {
      if (this.inses == 0) {
        this.typeListes = "all";
      } else if (this.inses == 1) {
        this.typeListes = 1;
      } else if (this.inses == 2) {
        this.typeListes = 2;
      } else if (this.inses == 3) {
        this.typeListes = 3;
      } else {
        this.typeListes = 4;
      }
      Axios({
        headers: {
          token: localStorage.getItem("token"),
        },
        method: "get",
        url: "https://researchadmin.qudong.com/api/user_content/index",
        params: {
          status: this.typeListes,
          limit: this.limites,
          page: this.pageeses,
        },
      }).then((res) => {
        //////console.log(res);
        this.result = res.data.data.data;
        this.totales = res.data.data.total;
      });
    },
    // 研报
    Report() {
      if (this.inss == 0) {
        this.typeLists = 0;
      } else if (this.inss == 1) {
        this.typeLists = 1;
      } else if (this.inss == 2) {
        this.typeLists = 2;
      } else if (this.inss == 3) {
        this.typeLists = 3;
      } else {
        this.typeLists = 4;
      }
      Axios({
        headers: {
          token: localStorage.getItem("token"),
        },
        method: "get",
        url: "https://researchadmin.qudong.com/api/article/userReport",
        params: {
          type: this.typeLists,
          limit: this.limits,
          page: this.pages,
        },
      }).then((res) => {
        this.totals = res.data.data.total;
        this.report_list = res.data.data.data;
        //////console.log(this.report_list);
        // this.reports = [];
        // this.report_list.forEach((item) => {
        //   if (item.status == this.inss) {
        //     this.reports.push(item);
        //   }
        //   if (this.inss == 0) {
        //     this.reports.push(item);
        //   }
        // });
      });
    },
    // 专利
    query() {
      if (this.ins == 0) {
        this.typeList = 0;
      } else if (this.ins == 1) {
        this.typeList = 1;
      } else if (this.ins == 2) {
        this.typeList = 2;
      } else if (this.ins == 3) {
        this.typeList = 3;
      } else {
        this.typeList = 4;
      }
      Axios({
        headers: {
          token: localStorage.getItem("token"),
        },
        method: "get",
        url: "https://researchadmin.qudong.com/api/article/userPatent",
        params: {
          type: this.typeList,
          limit: this.limit,
          page: this.page,
        },
      }).then((res) => {
        this.Hot_list = res.data.data.data;
        //////console.log(this.Hot_list);
        this.total = res.data.data.total;
      });
    },
    tab(index) {
      this.ins = index;
      this.query();
    },
    tabs(indexs) {
      this.inss = indexs;
      this.Report();
    },
    tabes(indexes) {
      this.inses = indexes;
      this.querylist();
    },
    handleClick(tab, event) {
      ////////console.log(tab, event);
      sessionStorage.setItem("currentTabs", tab.name);
    },
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.query();
    },
    handleCurrentChanges(newPages) {
      this.pages = newPages;
      this.Report();
    },
    handleCurrentChangees(newPagess) {
      this.pageeses = newPagess;
      this.querylist();
    },
    // 专利撤回
    messageList(id) {
      this.$confirm("是否撤回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          userinfo_withdrawpatent({
            id: id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "撤回成功!",
              });
            }
            this.query();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 专利重新上线
    popList(id) {
      this.$confirm("是否重新上线", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          article_userAgain({
            id: id,
            type: this.type1,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "上线成功!",
              });
            }
            this.query();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 专利删除
    deletelist(id) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delpatent({
            id: id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
            this.query();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 研报撤回
    messageLists(id) {
      this.$confirm("是否撤回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          userinfo_withdrawreport({
            id: id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "撤回成功!",
              });
            }
            this.Report();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 资讯撤回
    messageListes(id) {
      this.$confirm("是否撤回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          withdraw({
            id: id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "撤回成功!",
              });
            }
            this.querylist();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 研报重新上线
    popLists(id) {
      this.$confirm("是否重新上线", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          article_userAgain({
            id: id,
            type: this.type2,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "上线成功!",
              });
            }
            this.Report();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 资讯重新上线
    popListes(id) {
      this.$confirm("是否重新上线", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          article_userAgain({
            id: id,
            type: this.type3,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "上线成功!",
              });
            }
            this.querylist();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 资讯删除
    deletelistes(id) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          userinfo_delcontent({
            id: id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
            this.querylist();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 研报删除
    deletelists(id) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          del_report({
            id: id,
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
            this.Report();
            this.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 专利修改
    amendList(id) {
      this.$confirm("是否修改", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/PersonalCenter/Patent",
            query: { id: id, type: this.type1 },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 研报修改
    amendLists(id) {
      this.$confirm("是否修改", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/PersonalCenter/ResearchReport",
            query: { id: id, type: this.type2 },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 资讯修改
    amendListe(id) {
      this.$confirm("是否修改", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/PersonalCenter/ReleaseInformation",
            query: { id: id, type: this.type3 },
          });
        })
        .catch(() => {
          //////console.log(111);
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>
<style scoped>
.consend {
  width: 100%;
  margin: 0 auto;
}
.consend_title {
  width: 100%;
  margin: 0 auto;
  background: #fff;
}
.consend_title_top {
  width: 872px;
  margin: 0 auto;
}
.consend >>> .el-tabs__item {
  font-size: 18px;
  font-family: PingFang SC;
  height: 47px;
}
.consend >>> .el-tabs__nav {
  margin-left: 30px;
}
.consend >>> .el-tag {
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  margin-bottom: 9px;
}
.consend_title_top_fist {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 334px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.consend_bottom_left {
  display: flex;
}
.consend_bottom_img {
  width: 128px;
  height: 82px;
}
.consend_middle {
  height: 121px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
}
.text_middle {
  display: flex;
}
.text_bottom {
  display: flex;
}
.consend_right {
  display: flex;
}
.consend_bottom_text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #111111;
  margin-bottom: 15px;
}
.consend_bottom_data {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-right: 8px;
}
.consend_bottom_t {
  margin-right: 24px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.consend_bottom_i {
  margin-right: 10px;
}
.icon_img {
  margin-right: 8px;
  margin-top: 60px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3463db;
}
.icon_text {
  margin-top: 60px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3463db;
}
.condent_page {
  margin-top: 40px;
}
.active {
  color: #3463db;
}
</style>